<template>
    <slot v-if="valid"></slot>
</template>

<script lang="ts">
    import { ref, computed } from "vue";
    import { useStore } from "vuex";

    export default {
        props: {
            claim: {
                type: String,
                default: () => {
                    return null
                }
            }
        },

        setup(props) {
            const store = useStore();
            const userData = computed(() => { return store.getters.currentUser as any });
            const userClaims = ref(userData.value.userdata.claims);

            const valid = ref(true);

            if (props.claim)
                valid.value = userClaims.value.some((item: any) => item.nome == props.claim);

            return {
                valid
            }
        }
    }
</script>